import { render, staticRenderFns } from "./CreateCarstock.vue?vue&type=template&id=01df1c30&"
import script from "./CreateCarstock.vue?vue&type=script&lang=js&"
export * from "./CreateCarstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports